import React, { useEffect } from 'react';

import { Button, Col, Row } from 'reactstrap';
import { AttachmentDto, CreateEmailDto } from '../../CreateEmailDto';
import { FormState } from 'react-hook-form';
import { AttachmentInput } from './AttachmentInput';
import { FileContent, useImperativeFilePicker } from 'use-file-picker';
import { AttachmentInputList } from './AttachmentInputList';

interface PropTypes {
  attachments: AttachmentDto[];
  formState: FormState<CreateEmailDto>;
  onClose: () => void;
  setAttachments: (attachments: AttachmentDto[]) => void;
}

function handleChange(
  filesContent: FileContent[],
  setAttachments: (attachments: AttachmentDto[]) => void,
) {
  const attachmentsDto: AttachmentDto[] = filesContent.map(
    (fileContent: FileContent) => {
      return {
        filename: fileContent.name,
        contentBase64: fileContent.content,
      };
    },
  );

  setAttachments(attachmentsDto);
}

function EmailButtons(props: {
  formState: FormState<CreateEmailDto>;
  onClose: () => void;
}) {
  return (
    <Col className='d-flex justify-content-end'>
      <Button
        type='button'
        className='me-2'
        color='danger'
        onClick={() => props.onClose()}
      >
        Cancel
      </Button>
      <Button type='submit' color='primary' disabled={!props.formState.isValid}>
        Send
      </Button>
    </Col>
  );
}

export function EmailFooter(props: PropTypes) {
  const maxFileSizeMb = 2;
  const maxFiles = 6;

  const [openFileSelector, { filesContent, errors, removeFileByIndex }] =
    useImperativeFilePicker({
      multiple: true,
      readAs: 'DataURL',
      maxFileSize: maxFileSizeMb,
      readFilesContent: true,
      limitFilesConfig: { max: maxFiles },
    });

  useEffect(() => {
    handleChange(filesContent, props.setAttachments);
  }, [filesContent]);

  return (
    <>
      <AttachmentInputList
        attachments={props.attachments}
        errors={errors}
        removeFileByIndex={removeFileByIndex}
      />
      <Row className='d-flex flex-nowrap align-items-center'>
        <Col>
          <AttachmentInput
            attachments={props.attachments}
            errors={errors}
            maxFiles={maxFiles}
            maxFileSizeMb={maxFileSizeMb}
            openFileSelector={openFileSelector}
            setAttachments={props.setAttachments}
          />
        </Col>
        <EmailButtons formState={props.formState} onClose={props.onClose} />
      </Row>
    </>
  );
}
